export enum FeatureToggle {
  fulfillmentPartnerIntegrationsResponseConfigurations = 'rt_fulfillment_partner_integrations_response_configurations_page',
}
